import { Suspense, lazy } from "react";
import { I18nextProvider } from "react-i18next";

import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { isProduction } from "@shared/utils/fullscriptEnv/fullscriptEnv";

import { experimentTesterI18n } from "./i18n";

const ExperimentTester = lazy(
  () => import(/* webpackChunkName: "development-experiment-tester" */ "../ExperimentTester")
);

const LazyExperimentTester = () => {
  const { isAdminImpersonating } = useSharedGlobalConfig();

  if (isProduction() && !isAdminImpersonating) return null;

  return (
    <Suspense fallback={null}>
      <I18nextProvider i18n={experimentTesterI18n}>
        <ExperimentTester />
      </I18nextProvider>
    </Suspense>
  );
};

export { LazyExperimentTester };
